import { makeAutoObservable } from 'mobx'
import { ROW_PER_PAGE } from '../constants/constant'
import { fetchIndustrialArea } from '../services/investmentService'
import { toast } from 'react-toastify'
import i18n from '../i18n'

class IndustrialAreaStore {
	isLoading = false
	data = []
	currentPage = 1
	hasNext = false
	searchTerm = ''

	constructor() {
		makeAutoObservable(this)
	}

	fetchData = async () => {
		if (this.isLoading) return

		this.isLoading = true
		try {
			const response = await fetchIndustrialArea(this.currentPage, ROW_PER_PAGE, this.searchTerm)
			if (this.currentPage === 1) {
				this.data = response.data.data
			} else {
				this.data = this.data.concat(response.data.data)
			}
			this.hasNext = response.data.hasNextPage
		} catch (error) {
			console.error(error)
			if (error.response) toast.error(error.response.data.message)
			else toast.error(i18n.t('service-error', { field: 'industrial area' }))
		} finally {
			this.isLoading = false
		}
	}

	nextPage = async () => {
		this.currentPage += 1
		await this.fetchData()
	}

	search = async (searchTerm) => {
		this.searchTerm = searchTerm
		this.currentPage = 1
		await this.fetchData()
	}

	resetState = () => {
		this.isLoading = false
		this.data = []
		this.currentPage = 1
		this.hasNext = false
		this.searchTerm = ''
	}
}

const industrialAreaStore = new IndustrialAreaStore()
export default industrialAreaStore
